/** @jsxImportSource @emotion/react */
import { CSSTransition } from 'react-transition-group';
import { css, keyframes } from '@emotion/react';
import * as React from 'react';

// ---------------------------------------------------------------------------------------------------------------------
//   Keyframes
// ---------------------------------------------------------------------------------------------------------------------

export const FADE_IN_KEYFRAMES = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const FADE_OUT_KEYFRAMES = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

// ---------------------------------------------------------------------------------------------------------------------
//   Animations
// ---------------------------------------------------------------------------------------------------------------------

export const FADE_IN_ANIMATION = css` animation: 1s ${FADE_IN_KEYFRAMES};`;

export const FADE_IN_ANIMATION_SHORT = css` animation: .5s ${FADE_IN_KEYFRAMES};`;

export const SHOW = css`
  animation: .4s ${FADE_IN_KEYFRAMES};
  animation-fill-mode: forwards;
`;

export const HIDE = css`
  animation: .4s ${FADE_OUT_KEYFRAMES};
  animation-fill-mode: forwards;
  display: none;
`;

const nodeRef = React.createRef<HTMLDivElement>()

// @ts-ignore
/**
 * Fades its child in/out. Control whether or not the child of this component is visible by setting the `in` property
 * to a boolean. 1000ms transition
 */
export const Fade = // @ts-ignore: CSSTransition does not have a generic type
    props => <CSSTransition
  {...props}
  unmountOnExit={true}
  mountOnEnter={true}
  classNames='fade'
  appear={true}
  timeout={500}
  nodeRef={nodeRef}
/>;

/**
 * Fades its child in/out. Control whether or not the child of this component is visible by setting the `in` property
 * to a boolean. 400ms transition
 */
export const FadeShort = // @ts-ignore: CSSTransition does not have a generic type
    props => <CSSTransition
  {...props}
  unmountOnExit={true}
  mountOnEnter={true}
  classNames='fade-short'
  appear={true}
  timeout={400}
  nodeRef={nodeRef}
/>;

/**
 * Fades its child in while sliding in from the right
 */
export const FadeInRight = // @ts-ignore: CSSTransition does not have a generic type
    props => <CSSTransition
  {...props}
  unmountOnExit={true}
  mountOnEnter={true}
  classNames='fade-in-right'
  appear={true}
  timeout={400}
  nodeRef={nodeRef}
/>;
